import React from 'react'

import { CheckboxField } from './CheckboxField'
import { CheckboxGroupField } from './CheckboxGroupField'
import { DefaultField } from './DefaultField'
import { FileUploadField } from './FileUploadField'
import { InformationPanelField } from './InformationPanelField'
import { TagsField } from './TagsField'
import {
  type CheckboxFormField,
  type CheckboxGroupFormField,
  type FieldComponentProps,
  type FileUploadFormField,
  type InformationPanelFormField,
  type TagsFormField
} from './fieldTypes'
import { type FormField as CustomFormField } from './useViewFormModal'

export const FormField = ({ field, onPreviewFile }: FieldComponentProps<CustomFormField>) => {

  switch (field.type) {
    case 'information-panel':
      return <InformationPanelField field={field as InformationPanelFormField} />
    case 'checkbox':
      return <CheckboxField field={field as CheckboxFormField} />
    case 'checkbox-group':
      return <CheckboxGroupField field={field as CheckboxGroupFormField} />
    case 'file-upload':
      return <FileUploadField field={field as FileUploadFormField} onPreviewFile={onPreviewFile} />
    case 'tags':
      return <TagsField field={field as TagsFormField} />
    default:
      return <DefaultField field={field} />
  }
}
